import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import Loader from '../../../../components/Loader';
import styles from '../../Pricing.module.css';
import { CheckIcon } from '../../icons';

const planDescription = (plan) => {
  if (plan.rewardInfo?.title || plan.rewardInfo?.info) {
    return (
      <>
        {plan.rewardInfo.title && <strong>{plan.rewardInfo.title}</strong>}
        {plan.rewardInfo.info && (plan.rewardInfo.title ? ' ' : '')}{plan.rewardInfo.info}
      </>
    );
  }
  if (plan.planLevel === 1) {
    return 'Invoicing, estimates, and core bookkeeping — free to start.';
  }
  return 'Online payments, faster payouts, and premium tools for growing businesses.';
};

const Plans = () => {
  const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/plans?recurring=monthly`);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        setPlans(data.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchPlans();
  }, []);

  if (error) {
    return (
      <section className={styles.sec}>
        <div className={styles.container}>
          <p className={styles.secLead}>Unable to load plans. Please try again later.</p>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.sec} id="plans">
      <div className={styles.containerWide}>
        <div className={`${styles.secHead} ${styles.secHeadCenter} ${styles.sr}`} data-sr>
          <span className={styles.eyebrow}><span className={styles.dot} />Plans</span>
          <h2>Choose your plan.</h2>
          <p className={styles.secLead}>Start free and upgrade when you need more — invoicing, accounting, and payments work together on every plan.</p>
        </div>

        {loading ? (
          <Loader />
        ) : plans.length === 0 ? (
          <p className={`${styles.secLead} ${styles.secHeadCenter}`}>No plans available right now. Please check back soon.</p>
        ) : (
          <div
            className={`${styles.pricing} ${
              plans.length === 2 ? styles.pricingTwo : plans.length === 1 ? styles.pricingOne : ''
            }`}
          >
            {plans.map((plan) => (
              <div
                key={plan.planLevel}
                className={`${styles.priceCard} ${plan.isRecomended ? styles.priceCardPro : ''} ${styles.srIn}`}
              >
                {plan.isRecomended && <span className={styles.priceTag}>Recommended</span>}
                <div className={styles.priceName}>{plan.title} plan</div>
                <div className={styles.priceAmt}>
                  {plan.price !== 0 ? (
                    <>
                      {plan.sellingPrice !== 0 && <del>${plan.sellingPrice}</del>}
                      ${plan.price}
                      <small> /{plan.recurring === 'yearly' ? 'yr' : 'mo'}</small>
                    </>
                  ) : (
                    <>$0</>
                  )}
                </div>
                {plan.price !== 0 && (
                  <div className={styles.pricePeriod}>Billed {plan.recurring}</div>
                )}
                <p className={styles.priceDesc}>{planDescription(plan)}</p>
                <ul className={styles.priceList}>
                  {plan.features.map((feature) => (
                    <li key={feature.title}>
                      <CheckIcon />
                      <span>
                        {feature.title}
                        {feature.info && (
                          <Tooltip title={feature.info} position="top" trigger="mouseenter" arrow>
                            <i className={`fa-regular fa-circle-info ${styles.infoIcon}`} />
                          </Tooltip>
                        )}
                      </span>
                    </li>
                  ))}
                </ul>
                <Link to={`${dashboardUrl}/signup?planType=${plan.planLevel}`} className={styles.btnYellow}>
                  Get started now
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Plans;
